const UserCard = ({ user, onEdit, onDelete}) => {

    const initials = user.name.split(' ').map(n => n[0]).join('').toUpperCase();

    return (
        <div className=" bg-primary-800 border border-primary-50 rounded-2xl p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-secondary-50 flex items-center justify-center
                text-secondary-800 text-sm font-bold font-mono shrink-0">
                    {initials}
            </div>
            <div>
                <p className="text-white font-medium text-sm">{user.name}</p>
                <p className="text-white text-xs font-mono">ID: {user.telegram_id}</p>
            </div>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
            <button
                onClick={() => 
                    onEdit(user)}
                className="border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl px-3 py-1.5 text-xs font-mono">
                EDIT
            </button>
            <button
                onClick={() => 
                    onDelete(user.telegram_id)}
                className="border border-danger-800 text-danger-800 bg-danger-50 rounded-xl px-3 py-1.5 text-xs font-mono">
                DELETE
            </button>
        </div>
    </div>
    );
};

export default UserCard;